import React, {Component} from 'react'
import {connect} from 'react-redux'
import PropTypes from "prop-types";

import {DaysCalendar} from './functionsCalendar'

//const dayState_NotVisible = 0
const dayState_Disabled = 1
const dayState_Enabled = 2
const dayState_FirstSelected = 4
const dayState_FirstSelected_Disabled = 5
const dayState_Selected_Enabled = 6
const dayState_Selected_Disabled = 7
const dayState_LastSelected = 8
const dayState_LastSelected_Disabled = 9
const dayState_now = 10

//const daysNames = ["LUN", "MAR", "MIE", "JUE", "VIE", "SAB", "DOM"];
//const daysNames = ["LUN", "MAR", "MER", "JEU", "VEN", "SAM", "DIM"];

//const monthNames = ["JANVIER", "FÉVRIER", "MARS", "AVRIL", "MAI", "JUIN",
//  "JUILLET", "AOÛT", "SEPTEMBRE", "OCTOBRE", "NOVEMBRE", "DÉCEMBRE"];

//const monthNames = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
//  "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"];

const Day = ({prop, onClickSelect}) =>{
  const now = new Date(Date.now())
  const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const date = new Date(prop.value)

  const value = prop.value
  var num = prop.num
  var classname = ''
  var onClick = () => onClickSelect(value)

  switch (prop.state) {
    case dayState_Disabled:
      classname = 'col-md-7ths col-sm-7ths col-xs-7ths dayState dayState_Disabled'
      onClick = undefined
      break;
    case dayState_Enabled:
      classname = 'col-md-7ths col-sm-7ths col-xs-7ths dayState dayState_Enabled'
      break;
    case dayState_FirstSelected:
      classname = 'col-md-7ths col-sm-7ths col-xs-7ths dayState dayState_FirstSelected'
      break;
    case dayState_FirstSelected_Disabled:
      classname = 'col-md-7ths col-sm-7ths col-xs-7ths dayState dayState_FirstSelected'
      onClick = undefined
      break;
    case dayState_Selected_Enabled:
      classname = 'col-md-7ths col-sm-7ths col-xs-7ths dayState dayState_Selected_Enabled'
      break;
    case dayState_Selected_Disabled:
      classname = 'col-md-7ths col-sm-7ths col-xs-7ths dayState dayState_Selected_Disabled'
      onClick = undefined
      break;
    case dayState_LastSelected:
      classname = 'col-md-7ths col-sm-7ths col-xs-7ths dayState dayState_LastSelected'
      break;
    case dayState_LastSelected_Disabled:
      classname = 'col-md-7ths col-sm-7ths col-xs-7ths dayState dayState_LastSelected'
      onClick = undefined
      break;
    case dayState_now:
      classname = 'col-md-7ths col-sm-7ths col-xs-7ths dayState dayState_now'
      break;
    default:
      classname = 'col-md-7ths col-sm-7ths col-xs-7ths '
      onClick = undefined
      num = ''
  }

  if (+date === +nowDate){
    classname += ' dayState_now'
  }

  return (
    <div className={classname} onClick={onClick}>
      {num}
    </div>
  )
}

class drawCalendar extends Component{
  static contextTypes = {
    router: PropTypes.object
  }

  render(){
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages, tab } = this.props.settings
    const langPlace = languages[langUrl].fastbooking.calendar
    const daysName = langPlace.daysshort
    const monthNames = langPlace.monthnames

    const {index, month, year, view, select, filter, onClickSelect} = this.props
    const daysCalendar = DaysCalendar(month, year, view, select, filter, tab)
    const name = 'drawCalendar' + index
    return (
			<div className={name}>
        <div className='row'>
          <div className='calendar-title' >
            {monthNames[month]} {year}
          </div>
        </div>
        <div className='calendar-week row'>
          {daysName.map((t, index) =>
            <div key={index} className='col-md-7ths col-sm-7ths col-xs-7ths' >
              {t}
            </div>
          )}
        </div>
        <div className='calendar-days'>
          {daysCalendar.map((week, index) =>
            <div key={index} className='row'>
              {week.map((prop, index) =>
                <Day key={index} prop={prop} onClickSelect={onClickSelect}/>
              )}
            </div>
          )}
        </div>
		  </div>
    )
  }
}

export default connect(
	(state) => ({settings: state.settings})
)(drawCalendar)



// WEBPACK FOOTER //
// ./src/shared/routes/components/calendar/drawCalendar.js